import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import Logo from "../components/Logo";
import { api, formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { identifier });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Something went wrong."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#080808", color: "#F5F5F5", position: "relative" }}>
      <div style={{ position: "absolute", top: "30%", left: "50%", transform: "translate(-50%, -50%)", width: 600, height: 600, borderRadius: "50%", background: "radial-gradient(circle, rgba(249,115,22,0.08), transparent 70%)", pointerEvents: "none" }} />
      <header className="px-6 py-5 flex items-center justify-between max-w-7xl mx-auto w-full">
        <Link to="/"><Logo size="sm" forceDark /></Link>
        <div className="text-sm text-gray-500">Remembered it? <Link to="/login" className="text-[#F97316] font-medium">Sign in</Link></div>
      </header>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="p-8 space-y-5" style={{ background: "#111111", border: "1px solid rgba(249,115,22,0.2)", borderRadius: 16 }}>
            {sent ? (
              <div className="text-center space-y-4">
                <div style={{ width: 56, height: 56, borderRadius: "50%", background: "rgba(16,185,129,0.12)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                  <Mail style={{ color: "#10b981" }} size={24} />
                </div>
                <h1 className="text-2xl font-bold font-display">Check your email</h1>
                <p className="text-sm text-gray-400 leading-relaxed">
                  If an account exists for <span className="text-white font-medium">{identifier}</span>, we've sent a reset link.
                  Open it within 1 hour to set a new password.
                </p>
                <Link to="/login" className="inline-block w-full h-12 leading-[3rem] bg-[#F97316] hover:bg-[#EA580C] btn-orange-primary text-white rounded-lg font-medium">
                  Back to sign in
                </Link>
              </div>
            ) : (
              <>
                <div>
                  <h1 className="text-2xl font-bold font-display">Reset password</h1>
                  <p className="text-sm text-gray-500 mt-1">Enter your phone or email — we'll send a reset link.</p>
                </div>
                <form onSubmit={submit} className="space-y-4">
                  <div>
                    <label className="text-sm font-medium text-gray-300">Phone or email</label>
                    <input
                      required
                      value={identifier}
                      onChange={(e) => setIdentifier(e.target.value)}
                      placeholder="9876543210 or you@example.com"
                      style={{ background: "#1A1A1A", color: "#F5F5F5" }}
                      className="mt-1 w-full border border-gray-600 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#F97316] focus:border-[#F97316]"
                    />
                  </div>
                  <button disabled={busy} className="w-full h-12 bg-[#F97316] hover:bg-[#EA580C] btn-press btn-orange-primary text-white rounded-lg font-medium disabled:opacity-50">
                    {busy ? "Sending…" : "Send reset link"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
